import React from "react";
import "./header.css"

// reactstrap components

import { Container, Row, Col } from "reactstrap";
import {connect} from "react-redux";
import * as Roles from "../../store/actions/roles";


class Header extends React.Component {
  render() {
    // const mystyle = {
    //   background: "linear-gradient(90deg, #38719d 0%, #b62377 100%) !important"
    // };
    let primaryColor="";
    let secondaryColor="";
    if(Roles.isCorporateUser(this.props.role) === true){
      primaryColor=this.props.corporatePrimaryColor !== null ? this.props.corporatePrimaryColor : this.props.primaryColor;
      secondaryColor=this.props.corporateSecondaryColor !== null ? this.props.corporateSecondaryColor : this.props.secondaryColor;
    }else{
    primaryColor=this.props.primaryColor !== null ? this.props.primaryColor : "#38719d"
    secondaryColor=this.props.secondaryColor !== null ? this.props.secondaryColor : "#b62377"
    }

    const mystyle={
      background: 'linear-gradient(90deg, #ffffff, '+primaryColor+')'
    }

    return (
      <>
        <div className="header pb-5 pt-5 pt-md-8" style={mystyle}>
          <Container fluid>
            <div className="header-body">
              <Row>
                <Col>
                </Col>
                <Col>

                </Col>
              </Row>
              <Row></Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    primaryColor:state.authentication.authenticatedUser.primaryColor,
    secondaryColor:state.authentication.authenticatedUser.secondaryColor,
    corporatePrimaryColor:state.authentication.authenticatedUser.corporatePrimaryColor,
    corporateSecondaryColor:state.authentication.authenticatedUser.corporateSecondaryColor,
    role:state.authentication.authenticatedUser.role
  }
}


export default connect(mapStateToProps) (Header);
